import React from 'react';
import './JobLogViewer.css';

export default function JobLogViewer({ title, jobId, status, logs, open, onToggleOpen, onDismiss, logViewerRef }) {
  if (!jobId) return null;
  return (
    <section className="log-viewer-section">
      <div className="log-viewer-header">
        <div className="log-viewer-title-row">
          <span className="log-viewer-title">{title}</span>
          {status && (
            <span className={`job-status-badge status-${status}`}>
              {status === 'pending'  ? 'Queued'     :
               status === 'running'  ? '● Running'  :
               status === 'complete' ? '✓ Complete' :
               status === 'error'    ? '✕ Error'    : status}
            </span>
          )}
        </div>
        <div className="log-viewer-controls">
          <button className="btn-secondary sm" onClick={onToggleOpen}>
            {open ? 'Collapse' : 'Expand'}
          </button>
          {(status === 'complete' || status === 'error') && onDismiss && (
            <button className="btn-secondary sm" onClick={onDismiss}>Dismiss</button>
          )}
        </div>
      </div>
      {open && (
        <div className="log-viewer" ref={logViewerRef}>
          {logs.length === 0
            ? <span className="log-line log-muted">Waiting for job to start…</span>
            : logs.map((line, i) => <div key={i} className="log-line">{line}</div>)
          }
        </div>
      )}
    </section>
  );
}
